import store from '../store';

export const hasPermission = (requiredPermission: string): boolean => {
  const state = store.getState();
  const { permissions } = state.auth;

  return permissions.includes(requiredPermission);
};
